import { $ModuleArea, ModuleArea } from '@suntex.fim/enums';

import { NodeModel } from '../../../types';
import { buildNodeWithUnits } from '../../utils/buildNodeWithUnits';

const moduleAreaDesc = $ModuleArea.describe(ModuleArea.MeasurementWorld);

export const mwNode: NodeModel = {
  tag: moduleAreaDesc.slug,
  info: {
    title: moduleAreaDesc.label,
    summary: 'First in Science®',
  },
  label: {
    aria: moduleAreaDesc.label,
    class: 'MainLabel',
    frame: 5,
  },
  color: moduleAreaDesc.color,
  children: [
    buildNodeWithUnits({
      moduleSlug: 'equal-length',
      icon: 'games/equal-length',
      label: 'Equal Length',
      color: 0xcc3333,
    }),
    buildNodeWithUnits({
      moduleSlug: 'equal-weight',
      icon: 'games/equal-weight',
      label: 'Equal Weight',
      color: 0x9900cc,
    }),
    {
      moduleSlug: 'time-more-or-less',
      icon: 'games/time-more-or-less',
      label: 'Time More-or-Less',
      color: 0x3333cc,
    },
    {
      moduleSlug: 'equal-time',
      icon: 'games/equal-time',
      label: 'Equal Time',
      color: 0x3333cc,
    },
    {
      moduleSlug: 'passing-time',
      icon: 'games/passing-time',
      label: 'Passing Time',
      color: 0x3333cc,
    },
    {
      tag: 'equal-pay',
      icon: 'games/equal-pay',
      label: 'Equal Pay',
      color: 0x66cc66,
      children: [
        {
          moduleSlug: 'equal-pay',
          icon: 'games/equal-pay-dollars',
          label: 'Equal Pay - Dollars',
        },
        {
          tag: 'rupees',
          icon: 'games/equal-pay-rupees',
          label: 'Equal Pay - Rupees',
          layout: 'clock',
          children: [
            {
              moduleSlug: 'equal-pay-india',
              moduleVariant: 0,
              icon: 'games/equal-pay-rupees',
              label: 'Equal Pay Rupees\nLevel 1',
            },
            {
              moduleSlug: 'equal-pay-india',
              moduleVariant: 1,
              icon: 'games/equal-pay-rupees',
              label: 'Equal Pay Rupees\nLevel 2',
            },
          ],
        },
      ],
    },
    {
      tag: 'making-change',
      icon: 'games/making-change',
      label: 'Making Change',
      color: 0x009f00,
      children: [
        {
          moduleSlug: 'making-change',
          icon: 'games/making-change',
          label: 'Making Change - Dollars',
        },
        {
          tag: 'rupees',
          icon: 'games/making-change-rupees',
          label: 'Making Change - Rupees',
          layout: 'clock',
          children: [
            {
              moduleSlug: 'making-change-india',
              moduleVariant: 0,
              icon: 'games/making-change-rupees',
              label: 'Making Change Rupees\nLevel 1',
            },
            {
              moduleSlug: 'making-change-india',
              moduleVariant: 1,
              icon: 'games/making-change-rupees',
              label: 'Making Change Rupees\nLevel 2',
            },
          ],
        },
      ],
    },
    {
      moduleSlug: 'money-tiles',
      icon: 'games/money-tiles',
      label: 'Money\nTiles',
      color: 0x3e564b,
    },
    {
      tag: 'area-perimeter',
      icon: 'games/area-perimeter',
      label: 'Area/Perimeter',
      color: 0x0077cc,
      children: [
        buildNodeWithUnits({
          moduleSlug: 'area-perimeter-square',
          icon: 'shapes/square',
          label: 'Area/Perimeter\nSquare',
        }),
        buildNodeWithUnits({
          moduleSlug: 'area-perimeter-circle',
          icon: 'shapes/circle',
          label: 'Area/Perimeter\nCircle',
        }),
        buildNodeWithUnits({
          moduleSlug: 'area-perimeter-rectangle',
          icon: 'shapes/rectangle',
          label: 'Area/Perimeter\nRectangle',
        }),
        buildNodeWithUnits({
          moduleSlug: 'area-perimeter-triangle',
          icon: 'shapes/triangle',
          label: 'Area/Perimeter\nTriangle',
        }),
      ],
    },
  ],
};
